export class ParametresMobiles {
  constructor(
    public geolocOnInterEnabled = false,
    public telDispatcher?: string,
    public telDispatcherMobile?: string,
    public delaiVacationAvanceMinutes?: number
  ) {}

  public static hydrate(parametres: ParametresMobiles): ParametresMobiles {
    return new ParametresMobiles(
      parametres.geolocOnInterEnabled,
      parametres.telDispatcher,
      parametres.telDispatcherMobile,
      parametres.delaiVacationAvanceMinutes
    );
  }
}
